import { DESKTOP_BREAKPOINT } from '../config';
export var isMobileDevice = function () {
    if (window.matchMedia) {
        return !window.matchMedia("(min-width: ".concat(DESKTOP_BREAKPOINT, "px)")).matches;
    }
    return window.innerWidth <= DESKTOP_BREAKPOINT;
};
